import ko from 'knockout';

// https://gist.github.com/codethug/4657291
/**
 * Binding to display message to user before page leave
 * @example
 * <p data-bind="beforeUnload: ko.observable("some text")"></p>
 * <p data-bind="beforeUnload: { promptText: ko.observable("some text"), condition: ko.observable(true) }"></p>
 */
ko.bindingHandlers.beforeUnload = {

  init: function (element, valueAccessor) {
    window.onbeforeunload = function () {
      var value = valueAccessor();
      var data = ko.utils.unwrapObservable(value);
      var dataIsPromptText = typeof data === 'string';
      var promptText = dataIsPromptText ? data : ko.utils.unwrapObservable(data.promptText);
      var condition = dataIsPromptText ? true : ko.utils.unwrapObservable(data.condition);

      if (!!promptText && condition) {
        return promptText;
      }
    };
  }
};
